"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyLink = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_link_1 = require("@hotelplan/components.common.link");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const ButtonWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    '> p': {
        pr: 1,
        mt: 2,
        '.privacy-link': {
            color: 'primary',
        },
    },
}));
const PrivacyLink = ({ i18nKey }) => {
    // @ts-ignore
    const [t] = (0, next_i18next_1.useTranslation)(i18nKey.split(':').slice(0, 1));
    return (react_1.default.createElement(next_i18next_1.Trans, { i18nKey: i18nKey, components: [
            react_1.default.createElement(components_common_link_1.Link, { key: "privacy", target: '_blank', className: "privacy-link", 
                // @ts-ignore
                href: t('forms:privacy.link') }),
        ] }));
};
exports.PrivacyLink = PrivacyLink;
const SubmitWithPrivacyButtonWrapper = ({ className, children, }) => {
    return (react_1.default.createElement(ButtonWrapper, { className: className },
        children,
        react_1.default.createElement("p", { className: "privacy-link-text" },
            react_1.default.createElement(exports.PrivacyLink, { i18nKey: 'forms:privacy.title' }))));
};
exports.default = SubmitWithPrivacyButtonWrapper;
//# sourceMappingURL=PrivacyLink.js.map